import { render, staticRenderFns } from "./OPENVPNHistoryList.vue?vue&type=template&id=d38316e0&"
import script from "./OPENVPNHistoryList.vue?vue&type=script&lang=js&"
export * from "./OPENVPNHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports